// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/style/reset.css'
import './assets/style/global.css'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

import { pagination } from 'element-ui'

Vue.config.productionTip = false

Vue.use(pagination)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js